import './post.scss'

import React from 'react'
import PropTypes from 'prop-types'

const QuoteBlock = ({ content, style }) => {
  if (!content) return null

  return (
    <>
      <div
        className="quote-block"
        dangerouslySetInnerHTML={{ __html: content }}
        style={style}
      ></div>
    </>
  )
}

QuoteBlock.propTypes = {
  content: PropTypes.string.isRequired,
  style: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
}

export default QuoteBlock
